<template>
  <asc-dialog
    class="asc-create-powerbi-dashboard-dialog--container"
    :show-title="true"
    :show-dialog="showDialog"
    :on-close="handleClose"
    text="Create a new Dashboard"
    full-width-buttons
    :width="500"
  >
    <template v-if="showDialog">
      <div class="asc-create-powerbi-dashboard">
        <asc-power-bi-dashboard-name-airline-dataset-choice
          v-model="currentData"
          :mapped-powerbi-all-datasets="mappedPowerbiAllDatasets"
          :airlines-data="airlinesData"
          :dataset-data="datasetData"
          :dashboard-name-error-message="dashboardNameErrorMessage"
          :selected-workspace="selectedWorkspace"
        >
        </asc-power-bi-dashboard-name-airline-dataset-choice>
        <div class="asc-empty-div"></div>
        <v-card-actions>
          <v-row justify="space-between" no-gutters align="baseline">
            <v-col>
              <asc-accent-button
                :on-click="onSecondary"
                button-text="Cancel"
                custom-class="btn"
                :large="true"
                :outline="true"
                :secondary="true"
              ></asc-accent-button>
            </v-col>
            <v-col>
              <asc-accent-button
                :disabled="disabled"
                :loading="loading"
                :on-click="onPrimary"
                button-text="Create"
                :large="true"
                custom-class="btn"
              ></asc-accent-button>
            </v-col>
          </v-row>
        </v-card-actions>
      </div>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscLabel from '@/components/atoms/AscLabel'
import AscLinkButton from '@/components/atoms/AscLinkButton'
import AscPowerBiDashboardNameAirlineDatasetChoice from './AscPowerBiDashboardNameAirlineDatasetChoice.vue'

export default {
  name: 'AscCreatePowerBiDashboardDialog',

  components: {
    AscDialog,
    AscAccentButton,
    AscLabel,
    AscLinkButton,
    AscPowerBiDashboardNameAirlineDatasetChoice,
  },

  mixins: [AscDialogMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    customSubtitleClass: {
      type: String,
      default: '',
    },
    onSelection: {
      type: Function,
      default: () => {},
    },
    linkIcon: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '< Go Back',
    },
    buttonText: {
      type: String,
      default: 'Next',
    },
    onPrimary: {
      type: Function,
      default: () => {},
    },
    onSecondary: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: undefined,
    },
    checkButtons: {
      type: Boolean,
      default: false,
    },
    optionIcon: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    airlinesData: {
      type: Array,
      default: () => [],
    },
    datasetData: {
      type: Array,
      default: () => [],
    },
    mappedPowerbiAllDatasets: {
      type: Array,
      default: () => [],
    },
    selectedWorkspace: {
      type: Object,
      default: null,
    },
    dashboardNameErrorMessage: {
      type: String,
      default: '',
    },
  },

  computed: {
    currentData: {
      get() {
        return this.data
      },
      set(val) {
        this.$emit('handleUpdate', val)
      },
    },
  },
}
</script>

<style lang="scss">
.asc-create-powerbi-dashboard-dialog--container {
  .selection {
    background-color: $accent-100 !important;
  }

  .v-icon {
    top: -1px !important;
  }

  .asc-create-powerbi-dashboard {
    padding: 20px 10px;
    .asc-empty-div {
      height: 30px;
    }
    .dashboardName {
      .asc-input-field {
        .v-text-field__details {
          display: flex;
          flex-direction: row-reverse;
          .v-counter {
            width: 40px;
          }
        }
      }
    }
  }

  .btn {
    width: 90%;
  }
  .asc-flow-selection-dialog--container {
    .asc-dialog {
      .v-card {
        &__title {
          padding-bottom: 0 !important;
          height: 0;

          .asc-close-button {
            right: -2px;
            top: -3px;

            .v-icon {
              color: $primary-black !important;
              font-weight: bold;
            }
          }
        }

        &__text {
          padding-bottom: 16px !important;

          .asc-flow-selection {
            &--header {
              margin-bottom: 15px;
              padding: 8px 25px 0 8px;

              .title {
                color: $primary-black;
                font-size: $font-size-md !important;
                font-weight: 500;
                letter-spacing: 1px !important;
                line-height: 18px;
                margin: 0 0 14px 0;
                text-transform: uppercase;
              }

              .subtitle {
                color: $gray-1000;
                font-size: $font-size-md;
                letter-spacing: 0;
                line-height: 18px;
                margin: 0;
                padding-top: 20px;
              }
            }

            &--options {
              .asc-flow-selection--option {
                margin-bottom: 1px;
                padding: 10px 16px 18px 16px;

                .v-btn__content {
                  display: inline;
                }

                .v-icon {
                  float: right;
                }

                .asc-label.description {
                  margin: 14px 0 0 0;
                  line-height: 18px;
                  display: block;
                }

                &:last-child {
                  margin-bottom: 10;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
